const { VUE_APP_VERSION, VUE_APP_PUBLIC_PATH } = process.env;
const APP_PATH = 'wave';

export default {
  version: VUE_APP_VERSION,
  tokenExpire: 0.5, // トークンの有効期限
  cookiePath: VUE_APP_PUBLIC_PATH || '/wavepro/', // トークンのクッキーパス
  cookieUsersPath: '/users/', // ユーザー管理画面のクッキーパス
  cookieAquaPath: '/aqua/',
  slackClientId: '10648933349.6534435737442',

  defaultAppEnv: 'alphaus',
  defaultApiEnv: 'dev',
  apiPort: 8080, // API port (default)

  // Maintenance
  maintenance: {
    start: '2019-12-27 18:00',
    end: '2020-01-03 10:00',
  },

  // Application URL
  appUrl: {
    alphaus: {
      prod: 'https://app.alphaus.cloud',
      next: 'https://next.alphaus.cloud',
      dev: 'https://appdev.alphaus.cloud',
      // local: `http://localhost:{port}`,
    },
    localhost: `http://localhost:{port}`,
  },

  // API endpoint conditions
  apiUrl: {
    alphaus: {
      basic: {
        prod: `https://api.alphaus.cloud/m/${APP_PATH}`,
        next: `https://apinext.alphaus.cloud/m/${APP_PATH}`,
        dev: `https://apidev.alphaus.cloud/m/${APP_PATH}`,
        // localhost: `http://localhost:{port}/m/${APP_PATH}`,
        localhost: `http://localhost:{port}/`,
      },
      blue: {
        prod: `https://api.alphaus.cloud/m/blue/`,
        next: `https://apinext.alphaus.cloud/m/blue/`,
        dev: `https://apidev.alphaus.cloud/m/blue/`,
        localhost: `https://apidev.alphaus.cloud/m/blue/`,
      },
      login: {
        prod: `https://login.alphaus.cloud/`,
        next: `https://loginnext.alphaus.cloud/`,
        dev: `https://logindev.alphaus.cloud/`,
        // localhost: `http://localhost:{port}/${APP_PATH}`,
        // localhost: `https://logindev.alphaus.cloud/`,
      },
      auth: {
        prod: `https://api.alphaus.cloud/m/auth/rbac/`,
        next: `https://apinext.alphaus.cloud/m/auth/rbac/`,
        dev: `https://apidev.alphaus.cloud/m/auth/rbac/`,
        // localhost: `http://localhost:{port}/m/auth/rbac/`,
        // localhost: `https://apidev.alphaus.cloud/m/auth/rbac/`,
        // localhost: `https://logindev.alphaus.cloud/`,
      },
      status: {
        prod: `https://api.alphaus.cloud/m/status/`,
        next: `https://apinext.alphaus.cloud/m/status/`,
        dev: `https://apidev.alphaus.cloud/m/status/`,
        // localhost: `http://localhost:{port}/m/status/`,
        // localhost: `https://apidev.alphaus.cloud/m/status/`,
        // localhost: `https://logindev.alphaus.cloud/`,
      },
      user: {
        prod: `https://api.alphaus.cloud/m/u/users/`,
        next: `https://apinext.alphaus.cloud/m/u/users/`,
        dev: `https://apidev.alphaus.cloud/m/u/users/`,
        // localhost: `http://localhost:{port}/m/u/users/`,
        // localhost: `https://apidev.alphaus.cloud/m/u/users/`,
        // localhost: `https://logindev.alphaus.cloud/`,
      },
      mfa: {
        prod: `https://api.alphaus.cloud/m/mfa/`,
        next: `https://apinext.alphaus.cloud/m/mfa/`,
        dev: `https://apidev.alphaus.cloud/m/mfa/`,
        // localhost: `http://localhost:{port}/m/mfa/`,
        // localhost: `https://apidev.alphaus.cloud/m/mfa/`,
        // localhost: `https://logindev.alphaus.cloud/`,
      },
    },
    localhost: {
      basic: {
        localhost: `http://localhost:{port}/m/${APP_PATH}`,
      },
      blue: {
        localhost: `http://localhost:{port}/m/blue/`,
      },
      login: {
        localhost: `http://localhost:{port}/${APP_PATH}`,
      },
      auth: {
        localhost: `http://localhost:{port}/m/auth/rbac/`,
      },
      status: {
        localhost: `http://localhost:{port}/m/status/`,
      },
      user: {
        localhost: `http://localhost:{port}/m/u/users/`,
      },
      mfa: {
        localhost: `http://localhost:{port}/m/mfa/`,
      },
    },
  },
  appSubDomain: {
    alphaus: {
      app: 'prod',
      next: 'next',
      appdev: 'dev',
      login: 'prod',
      loginnext: 'next',
      logindev: 'dev',
    },
  },
  clientId: {
    alphaus: {
      prod: '8cb7922d449c01c435e6db54bc857f4c0e4e62ad1054a5df879704ca1b1bf894',
      next:
        'jD9oW7AZBeNN6HQXfi6Gjrwekrer9PavdYKhSnWKbveTzCvkr68mzUktkUkHfdztgEqcx8aw8NbAG6eCurxf2Y',
      dev: '8cb7922d449c01c435e6db54bc857f4c0e4e62ad1054a5df879704ca1b1bf894',
      localhost: '8cb7922d449c01c435e6db54bc857f4c0e4e62ad1054a5df879704ca1b1bf894',
    },
  },
  clientSecret: {
    alphaus: {
      prod:
        'f8117b1ac72ab7543519823aaa0e40896b60db0ee864389e9aca7a8c23f6acce3a6493f0afd12aa876d3a69d4fddfa72007e0a622ee40ae68ba3b09b98973c9df084e07149e97262f332e4bc2c6ded6e07124a892ab9b600d381a954ede9884e2aad9c1578d7c141f6c65049ceb703676cbb95430fdd98471803c2633cbecc7dec8efd474e5b0010f2e26d4746af7811b7acb9ff1de5e903fdb46d4dbe5ce47e1af63ba5d1f35bd65cd06f8953ab0d0c471f45f8a0942e2891dfa52070d694f7d8e1ec8eb6393b92b177529fc57c3b6f774a61b6289adfd366d8b554e44753f635533fbc5523a75f07fb93048bf7a580562f31f876b8059a1d865270d9e74177',
      next:
        'd52mfosScd8vo4NoucbWJxoh4AoMAYuCF5CfpxvoEqjGbaFsxLrVXkdCeHbZ6JAmytiJHQcHVcnjdtNtgpE4yt4bjN9UPk4RvK8wZU9QH7VTrWHxTWFnXW9ripkSi83xBjoYLRHrGpzLca3rNAKBMSxLeP5sZ4anpTFru9tCGTx3MYp5ZKevvyEhRzfkq3THk3LZXz2a5BFBxVj5aNzugf3KEj9DY47zkW9wL4PpG28mDrsDx3zRpdLGj8fD6ErB',
      dev:
        'f8117b1ac72ab7543519823aaa0e40896b60db0ee864389e9aca7a8c23f6acce3a6493f0afd12aa876d3a69d4fddfa72007e0a622ee40ae68ba3b09b98973c9df084e07149e97262f332e4bc2c6ded6e07124a892ab9b600d381a954ede9884e2aad9c1578d7c141f6c65049ceb703676cbb95430fdd98471803c2633cbecc7dec8efd474e5b0010f2e26d4746af7811b7acb9ff1de5e903fdb46d4dbe5ce47e1af63ba5d1f35bd65cd06f8953ab0d0c471f45f8a0942e2891dfa52070d694f7d8e1ec8eb6393b92b177529fc57c3b6f774a61b6289adfd366d8b554e44753f635533fbc5523a75f07fb93048bf7a580562f31f876b8059a1d865270d9e74177',
      localhost:
        'f8117b1ac72ab7543519823aaa0e40896b60db0ee864389e9aca7a8c23f6acce3a6493f0afd12aa876d3a69d4fddfa72007e0a622ee40ae68ba3b09b98973c9df084e07149e97262f332e4bc2c6ded6e07124a892ab9b600d381a954ede9884e2aad9c1578d7c141f6c65049ceb703676cbb95430fdd98471803c2633cbecc7dec8efd474e5b0010f2e26d4746af7811b7acb9ff1de5e903fdb46d4dbe5ce47e1af63ba5d1f35bd65cd06f8953ab0d0c471f45f8a0942e2891dfa52070d694f7d8e1ec8eb6393b92b177529fc57c3b6f774a61b6289adfd366d8b554e44753f635533fbc5523a75f07fb93048bf7a580562f31f876b8059a1d865270d9e74177',
    },
  },
};
